import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import { Invitation, User, B2bUnit, ContactFormData, Address } from '@kion/data-models';

export const inviteUserSuccess = createActionWithCorrelation(
  "[User] invite user success",
  props<{}>()
);
export const inviteUserError = createActionWithCorrelation(
  "[User] invite user error",
  props<{ error: any }>()
);
export const inviteUser = createActionWithCorrelation(
  "[User] invite user",
  props<{ invitation: Invitation, isAdmin?: boolean }>(),
  inviteUserSuccess.type,
  inviteUserError.type
);

export const validateInvitationTokenSuccess = createActionWithCorrelation(
  "[User] validate invitation token success",
  props<{}>()
);
export const validateInvitationTokenError = createActionWithCorrelation(
  "[User] validate invitation token error",
  props<{ error: any }>()
);
export const validateInvitationToken = createActionWithCorrelation(
  "[User] validate invitation token",
  props<{ email: string, token: string }>(),
  validateInvitationTokenSuccess.type,
  validateInvitationTokenError.type
);

export const registerUserSuccess = createActionWithCorrelation(
  "[User] register user success",
  props<{ }>()
);
export const registerUserError = createActionWithCorrelation(
  "[User] register user error",
  props<{ error: any }>()
);
export const registerUser = createActionWithCorrelation(
  "[User] register user",
  props<{
    accessToken: string,
    identityToken: string,
    firstName: string,
    lastName: string,
    email: string,
    idp: string,
    oid: string
    invitationToken?: string
    address: Partial<Address>
  }>(),
  registerUserSuccess.type,
  registerUserError.type
);

export const resendInviteUserSuccess = createActionWithCorrelation(
  "[User] resend invite user success",
  props<{}>()
);
export const resendInviteUserError = createActionWithCorrelation(
  "[User] resend invite user error",
  props<{ error: any }>()
);
export const resendInviteUser = createActionWithCorrelation(
  "[User] resend invite user",
  props<{ invitationId: string }>(),
  resendInviteUserSuccess.type,
  resendInviteUserError.type
);

export const deleteInvitationSuccess = createActionWithCorrelation(
   "[User] delete invitation success",
   props<{}>()
);
export const deleteInvitationError = createActionWithCorrelation(
   "[User] delete invitation error",
   props<{ error: any }>()
);
export const deleteInvitation = createActionWithCorrelation(
   "[User] delete invitation",
   props<{ invitationId: string }>(),
   deleteInvitationSuccess.type,
   deleteInvitationError.type
);

export const loadUserByIdSuccess = createActionWithCorrelation(
  "[User] load user by id success",
  props<{ user: User }>()
);
export const loadUserByIdError = createActionWithCorrelation(
  "[User] load user by id error",
  props<{ error: any }>()
);
export const loadUserById = createActionWithCorrelation(
  "[User] load user by id",
  loadUserByIdSuccess.type,
  loadUserByIdError.type
);

export const updateB2bUnitSuccess = createActionWithCorrelation(
  "[User] update B2BUnit success",
  props<{ }>()
);
export const updateB2bUnitError = createActionWithCorrelation(
  "[User] update B2BUnit error",
  props<{ error: any }>()
);
export const updateB2bUnit = createActionWithCorrelation(
  "[User] update B2bUnit",
  props<{ b2bUnitId: string, registration: B2bUnit }>(),
  updateB2bUnitSuccess.type,
  updateB2bUnitError.type
);

export const submitContactFormSuccess = createActionWithCorrelation(
  "[User] create address success",
  props<{ data: ContactFormData }>(),
);
export const submitContactFormError = createActionWithCorrelation(
  "[User] create address error",
  props<{ data: ContactFormData, error: any }>(),
);
export const submitContactForm = createActionWithCorrelation(
  "[User] create address",
  props<{ data: ContactFormData }>(),
  submitContactFormSuccess.type,
  submitContactFormError.type
);
